import {
  DriverType,
  ExcludedDriverType,
  VersionedObjectDiff,
} from '@clearcover/core-app-types';
import React from 'react';
import { PolicyChangeDriverDetails } from './PolicyChangeDriverDetails';
import {
  PolicyChangeCard,
  changeTypes,
  getCurrentData,
  joinNonEmpty,
} from '../PolicyChangeCard/PolicyChangeCard';
import { ChangeCardAndDetails } from '../PolicyChangeCard/types';

export const toDriverCardAndDetails = (
  diff: VersionedObjectDiff<DriverType | ExcludedDriverType>
): ChangeCardAndDetails => {
  const { firstName, lastName } = getCurrentData(diff).person.name;
  const title = `Driver ${changeTypes[diff.type]}`;
  const value = joinNonEmpty(firstName, lastName);

  return {
    card: ({ 'data-testid': dataTestId, selected, onClick }) => (
      <PolicyChangeCard
        data-testid={dataTestId}
        title={title}
        onClick={onClick}
        selected={selected}
        type="driver"
        action={diff.type}
        value={value}
      />
    ),
    details: () => <PolicyChangeDriverDetails diff={diff} />,
    metadata: {
      type: 'driver',
      action: diff.type,
      title,
      value,
    },
  };
};
